import Create from "./Create";
import List from "./List";

export default function Subzones() {
    return (
        <>
        <Create/>
        <List/>
        </>
    )
}
